import { Box, Typography, IconButton, Dialog, DialogTitle, DialogContent, Paper, MenuItem, Divider, Grid, Button } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { FormProvider, useForm } from "react-hook-form";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { CardInformation } from "./CardInformation";
import { CardRewards } from "./CardRewards";
import { ItemRewarded } from "./ItemRewarded";
import { Discount } from "./Discount";

interface CardProcessingProps {
  open: boolean;
  onClose: () => void;
}

export const CardProcessing: React.FC<CardProcessingProps> = ({ open,onClose }) => {
    const methods = useForm();
    const { handleSubmit, control, register } = methods;

  const tabs = [
    { label: "Card Information", content:<CardInformation/>},
    { label: "Card Rewards", content: <CardRewards/> },
    { label: "Item Rewarded", content: <ItemRewarded/> },
    { label: "Discount", content: <Discount/> },
  ];  
  
  const onSubmit = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  return (
    <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    PaperProps={{
      style: {
        backgroundColor: "whitesmoke",
      },
    }}
  >
    <FormProvider {...methods}>
    <form onSubmit={handleSubmit(onSubmit)}>      
    <DialogTitle  sx={{backgroundColor:"green"}}>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" color={"white"}>Card Processing</Typography>
        <IconButton onClick={onClose}>
          <WSIcons.CloseIcon sx={{color:"white"}}/>
        </IconButton>
      </Grid>
    </DialogTitle>
    <DialogContent>
        <Grid container spacing={4} sx={{mt:1}}>
            <Grid item xs={12} sm={2}>
                <Typography>Card No</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
            <WSTextField
          label={""}
          {...register("cardno")}
          id="cardno"
          name="cardno"
          control={control}
          rules={{ required: true }}
        />
            </Grid>
            <Grid item xs={12} sm={1}>
                <WSIcons.CreditCardIcon/>
            </Grid>
            <Grid item xs={12} sm={1}>
                <WSIcons.SearchIcon/>
            </Grid>
            <Grid item xs={12} sm={4}>
            <Button
          variant="outlined"
          sx={{borderColor: "green", 
            color: "black",}}
        >
         Show Card Information
        </Button>
            </Grid>
        <Grid item xs={12}>
         
            <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />
        </Grid>
        </Grid>
    
        </DialogContent>
        <Grid
      item
      mt={2}
      sx={{
        backgroundColor: "#333",
        padding: 2,
      }}
    >
      <Grid container alignItems="center" justifyContent="space-between">
        {/* Left-aligned icon */}
        <Grid item>
          <WSIcons.GTranslateIcon fontSize="medium" sx={{ color: "#fff" }} />
        </Grid>

        {/* Right-aligned buttons */}
        <Grid item>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2, // Add spacing between the buttons
            }}
          >
            <Button variant="outlined" sx={{borderColor:"green",color:"white"}} onClick={onSubmit}>
              No Card
            </Button>
            <Button variant="contained" color="success" onClick={handleSubmit(onSubmit)}>
              Finish
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
      </form>
      </FormProvider>
  </Dialog>
  );
};
